var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-link',_vm._g(_vm._b({attrs:{"href":_vm.compiledHref},scopedSlots:_vm._u([(_vm.glSlots().default)?{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}:null],null,true)},'gl-link',_vm.attributes,false),_vm.glListeners()))
}
var staticRenderFns = []

export { render, staticRenderFns }